export const GET_MANAGE_ORGANIZATION_INFO = "GET_MANAGE_ORGANIZATION_INFO";
export default {
  GET_MANAGE_ORGANIZATION_INFO,
};
